import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MaintenanceNavigationService } from '../services/maintenance-navigation.service';

export const maintenanceGuard: CanActivateFn = () => {
  const router = inject(Router);
  const maintenanceNavigationService = inject(MaintenanceNavigationService);

  if (maintenanceNavigationService.isMaintenanceNavigationAllowed()) {
    return true;
  }

  router.navigate(['/dashboard']);

  return false;
};
